import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);

export const submitQuote = (payload) =>
  axios.post(`${API}/quote`, payload).then((r) => r.data);

export const submitOrder = (payload) =>
  axios.post(`${API}/order`, payload).then((r) => r.data);

// ---------- AMWAP Supply (public) ----------
export const getSupplyProducts = (params = {}) =>
  axios.get(`${API}/supply/products`, { params }).then((r) => r.data);

export const getSupplyProduct = (id) =>
  axios.get(`${API}/supply/products/${id}`).then((r) => r.data);

export const getSupplyCategories = () =>
  axios.get(`${API}/supply/categories`).then((r) => r.data);

// ---------- AMWAP Supply (admin) ----------
export const adminGetProducts = (token) =>
  axios.get(`${API}/admin/supply/products`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminCreateProduct = (token, payload) =>
  axios.post(`${API}/admin/supply/products`, payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminUpdateProduct = (token, id, payload) =>
  axios.put(`${API}/admin/supply/products/${id}`, payload, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminDeleteProduct = (token, id) =>
  axios.delete(`${API}/admin/supply/products/${id}`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

// ---------- Square checkout ----------
export const startCheckout = (payload, token) =>
  axios.post(`${API}/payments/checkout`, payload, token ? { headers: { Authorization: `Bearer ${token}` } } : {}).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
  axios.get(`${API}/payments/status/${sessionId}`).then((r) => r.data);

export const adminGetSupplyOrders = (token) =>
  axios.get(`${API}/admin/supply/orders`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGetQuotes = (token) =>
  axios.get(`${API}/admin/quotes`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGetContacts = (token) =>
  axios.get(`${API}/admin/contacts`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGetStoreOrders = (token) =>
  axios.get(`${API}/admin/store-orders`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminUpdateSupplyOrderStatus = (token, orderId, status, tracking = "") =>
  axios.put(`${API}/admin/supply/orders/${orderId}/status`, { status, tracking }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGetReorderList = (token) =>
  axios.get(`${API}/admin/supply/reorder-list`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminGetDashboard = (token, range = "all") =>
  axios.get(`${API}/admin/dashboard`, { params: { range }, headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

// ---------- Customer accounts ----------
export const customerRegister = (payload) =>
  axios.post(`${API}/auth/register`, payload).then((r) => r.data);

export const customerLogin = (payload) =>
  axios.post(`${API}/auth/login`, payload).then((r) => r.data);

export const customerMe = (token) =>
  axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getScopedItems = (token) =>
  axios.get(`${API}/customer/scoped-items`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const getCustomerOrders = (token) =>
  axios.get(`${API}/customer/orders`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

const cAuth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });
export const getSavedLists = (token) => axios.get(`${API}/customer/lists`, cAuth(token)).then((r) => r.data);
export const createSavedList = (token, name) => axios.post(`${API}/customer/lists`, { name }, cAuth(token)).then((r) => r.data);
export const deleteSavedList = (token, id) => axios.delete(`${API}/customer/lists/${id}`, cAuth(token)).then((r) => r.data);
export const addToSavedList = (token, listId, productId) => axios.post(`${API}/customer/lists/${listId}/items`, { product_id: productId }, cAuth(token)).then((r) => r.data);
export const removeFromSavedList = (token, listId, productId) => axios.delete(`${API}/customer/lists/${listId}/items/${productId}`, cAuth(token)).then((r) => r.data);

export const adminGetCustomers = (token) =>
  axios.get(`${API}/admin/customers`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const adminSetScopedItems = (token, customerId, productIds, prices = {}) =>
  axios.put(`${API}/admin/customers/${customerId}/scoped-items`, { product_ids: productIds, prices }, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const uploadFile = (file, onProgress) => {
  const form = new FormData();
  form.append("file", file);
  return axios
    .post(`${API}/upload`, form, {
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded * 100) / e.total));
      },
    })
    .then((r) => ({
      ...r.data,
      url: `${BACKEND_URL}${r.data.url}`,
      poster_url: r.data.poster_url ? `${BACKEND_URL}${r.data.poster_url}` : null,
    }));
};

export const getReviews = () => axios.get(`${API}/reviews`).then((r) => r.data);

// ---------- Admin storage ----------
export const adminLogin = (passcode) =>
  axios.post(`${API}/admin/login`, { passcode }).then((r) => r.data.token);

export const getStorageStats = (token) =>
  axios.get(`${API}/admin/storage/stats`, { headers: { Authorization: `Bearer ${token}` } }).then((r) => r.data);

export const purgeStorage = (token, scope) =>
  axios
    .post(`${API}/admin/storage/purge`, { scope }, { headers: { Authorization: `Bearer ${token}` } })
    .then((r) => r.data);

// ---------- Careers (public) ----------
export const getJobs = () => axios.get(`${API}/jobs`).then((r) => r.data);

export const getJob = (id) => axios.get(`${API}/jobs/${id}`).then((r) => r.data);

export const applyToJob = (id, payload) =>
  axios.post(`${API}/jobs/${id}/apply`, payload).then((r) => r.data);

// ---------- Careers admin ----------
const authCfg = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const adminGetJobs = (token) =>
  axios.get(`${API}/admin/jobs`, authCfg(token)).then((r) => r.data);

export const adminCreateJob = (token, payload) =>
  axios.post(`${API}/admin/jobs`, payload, authCfg(token)).then((r) => r.data);

export const adminUpdateJob = (token, id, payload) =>
  axios.put(`${API}/admin/jobs/${id}`, payload, authCfg(token)).then((r) => r.data);

export const adminDeleteJob = (token, id) =>
  axios.delete(`${API}/admin/jobs/${id}`, authCfg(token)).then((r) => r.data);

export const adminGetApplications = (token) =>
  axios.get(`${API}/admin/applications`, authCfg(token)).then((r) => r.data);

export const adminUpdateApplicationStatus = (token, id, status) =>
  axios.put(`${API}/admin/applications/${id}`, { status }, authCfg(token)).then((r) => r.data);

export const adminUpdateApplicationNotes = (token, id, notes) =>
  axios.put(`${API}/admin/applications/${id}/notes`, { notes }, authCfg(token)).then((r) => r.data);

export const downloadApplicationPdf = async (token, id, name) => {
  const res = await axios.get(`${API}/admin/applications/${id}/pdf`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const link = document.createElement("a");
  const safe = (name || "application").replace(/[^a-z0-9 _-]/gi, "").trim().replace(/\s+/g, "_") || "application";
  link.href = url;
  link.download = `${safe}_application.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
